var exports = {
  "ignore": "ignore-aVo1N",
  "worst": "worst-aVo1N",
  "worse": "worse-aVo1N",
  "bad": "bad-aVo1N",
  "invocab": "invocab-aVo1N",
  "good": "good-aVo1N",
  "ok": "ok-aVo1N",
  "viewModeMenu": "viewModeMenu-aVo1N",
  "table": "table-aVo1N",
  "plainTextMenu": "plainTextMenu-aVo1N",
  "geo_words": "geo_words-aVo1N",
  "geo_lines": "geo_lines-aVo1N",
  "geo_paragraphs": "geo_paragraphs-aVo1N",
  "geo_blocks": "geo_blocks-aVo1N",
  "selectedWord": "selectedWord-aVo1N",
  "coordlessWord": "coordlessWord-aVo1N",
  "rightToLeft": "rightToLeft-aVo1N",
  "lineIndicator": "lineIndicator-aVo1N",
  "lineCount": "lineCount-aVo1N",
  "compareLineIndicator": "compareLineIndicator-aVo1N",
  "selectedLine": "selectedLine-aVo1N",
  "editInput": "editInput-aVo1N",
  "editedLabel": "editedLabel-aVo1N",
  "wordJoin": "wordJoin-aVo1N",
  "name": "name-aVo1N",
  "place": "place-aVo1N",
  "subject": "subject-aVo1N",
  "entity": "entity-aVo1N",
  "glossary": "glossary-aVo1N",
  "tableRow": "tableRow-aVo1N",
  "selected": "selected-aVo1N",
  "mutedRow": "mutedRow-aVo1N",
  "pageTreeCaption": "pageTreeCaption-aVo1N",
  "saveTextArea": "saveTextArea-aVo1N",
  "ocr_line": "ocr_line-aVo1N",
  "term": "term-aVo1N",
  "group": "group-aVo1N",
  "footnoteRef": "footnoteRef-aVo1N",
  "hocrFootnotes": "hocrFootnotes-aVo1N",
  "hocrFootnote": "hocrFootnote-aVo1N",
  "jumpBack": "jumpBack-aVo1N",
};

__webpack_require__.r(module.exports = exports);
